export const environment = {
	production: false,
	firebase: {
		apiKey: "AIzaSyA2PJvXjyFOxaDgECkKFPlHk12GKH33oUs",
		authDomain: "multigroup-sa.firebaseapp.com",
		databaseURL: "https://multigroup-sa.firebaseio.com",
		projectId: "multigroup-sa",
		storageBucket: "multigroup-sa.appspot.com",
		messagingSenderId: "123084572857",
		appId: "1:123084572857:web:dd07e4caa23c37c8717368"
	}
};
